// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/style/director-style.css
// module id = 1173
// module chunks = 0